module.exports = __webpack_public_path__ + "static/hero-simple-package-5281de7daa1ceaced0c5d11a7618908e.jpg";